import { AvatarStyle, BusMessage } from "flavr-common";
/**
 * command to AvatarLoader to load an avatar image from selfcare as texture and return a mesh.
 * Internal message.
 */
export class LoadAvatarMessage extends BusMessage {
    constructor(username, avatarStyle = AvatarStyle.Monitor) {
        super();
        this.username = username;
        this.avatarStyle = avatarStyle;
    }
    serialization() {
        throw new Error("LoadAvatarMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === LoadAvatarMessage.typestatic;
    }
}
LoadAvatarMessage.typestatic = "LoadAvatarMessage";
LoadAvatarMessage.subjectstatic = "local";
/**
 * AvatarLoader returns a loaded mesh as three 3d Object.
 * Internal message.
 */
export class AvatarLoadedMessage extends BusMessage {
    constructor(username, headMesh, shoulderMesh) {
        super();
        this.username = username;
        this.headMesh = headMesh;
        this.shoulderMesh = shoulderMesh;
    }
    serialization() {
        throw new Error("AvatarLoadedMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === AvatarLoadedMessage.typestatic;
    }
}
AvatarLoadedMessage.typestatic = "AvatarLoadedMessage";
AvatarLoadedMessage.subjectstatic = "local";
/**
 * Internal message.
 */
export class LoadMeshMessage extends BusMessage {
    /**
     * @param meshPathAndName path and file-name. In some cases abused with an "@" + fileId + ".gltf"
     * @param addBarycentricCoordinates Only set to true if you want to apply our wireframe-shader to the mesh later.
     * @param pieceName Name of a sub-mesh, I suppose.
     */
    constructor(meshPathAndName, addBarycentricCoordinates = false, pieceName) {
        super();
        this.meshPathAndName = meshPathAndName;
        this.addBarycentricCoordinates = addBarycentricCoordinates;
        this.pieceName = pieceName;
    }
    serialization() {
        throw new Error("LoadMeshMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === LoadMeshMessage.typestatic;
    }
}
LoadMeshMessage.typestatic = "LoadMeshMessage";
LoadMeshMessage.subjectstatic = "local";
/**
 * MeshLoader returns a loaded mesh as three3d Object
 * Internal message.
 */
export class MeshLoadedMessage extends BusMessage {
    constructor(meshName, mesh, pieceName, animationRoot) {
        super();
        this.meshName = meshName;
        this.mesh = mesh;
        this.pieceName = pieceName;
        this.animationRoot = animationRoot;
    }
    serialization() {
        throw new Error("MeshLoadedMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === MeshLoadedMessage.typestatic;
    }
}
MeshLoadedMessage.typestatic = "MeshLoadedMessage";
MeshLoadedMessage.subjectstatic = "local";
/**
 * Carries a media track for renderer-related handling.
 */
export class MediaTrackMessage extends BusMessage {
    constructor(uid, clientId, stream) {
        super();
        this.uid = uid;
        this.clientId = clientId;
        this.stream = stream;
    }
    serialization() {
        throw new Error("MediaTrackMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === MediaTrackMessage.typestatic;
    }
}
MediaTrackMessage.typestatic = "MediaTrackMessage";
MediaTrackMessage.subjectstatic = "local";
/**
 * Carries audio buffers for renderer-related playback.
 */
export class AudioBuffersMessage extends BusMessage {
    constructor(uid, started, buffers) {
        super();
        this.uid = uid;
        this.started = started;
        this.buffers = buffers;
    }
    serialization() {
        throw new Error("AudioBuffersMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === AudioBuffersMessage.typestatic;
    }
}
AudioBuffersMessage.typestatic = "AudioBuffersMessage";
AudioBuffersMessage.subjectstatic = "local";
export var ControlAudioBuffer;
(function (ControlAudioBuffer) {
    ControlAudioBuffer[ControlAudioBuffer["PAUSE"] = 0] = "PAUSE";
    ControlAudioBuffer[ControlAudioBuffer["RESUME"] = 1] = "RESUME";
})(ControlAudioBuffer || (ControlAudioBuffer = {}));
/**
 * Controls a renderer-managed audio buffer.
 */
export class ControlAudioBufferMessage extends BusMessage {
    constructor(uid, control) {
        super();
        this.uid = uid;
        this.control = control;
    }
    serialization() {
        throw new Error("ControlAudioBufferMessage should not be serialized");
    }
    static is(msg) {
        return msg.type === ControlAudioBufferMessage.typestatic;
    }
}
ControlAudioBufferMessage.typestatic = "ControlAudioBufferMessage";
ControlAudioBufferMessage.subjectstatic = "local";
